import AiLanguageSelect from './AiLanguageSelect'

export default AiLanguageSelect
